module.exports = __webpack_public_path__ + "media/images/logos/logo1_small_white-10bd81f89124666812423b0e38d43662.webp";